import { inject, Injectable } from '@angular/core';
import { TypeModel, TypesClient } from 'api-clients/applicant-api-client';
import { OrganizationDirectoryEntityType, DirectoryClient } from 'api-clients/agency-admin-api-client';

@Injectable()
export class DirectoryService {
  directoryStates: TypeModel[] = [];
  directoryEntitytypes: OrganizationDirectoryEntityType[] = [];

  readonly #directoryClient = inject(DirectoryClient);
  readonly #typesClient = inject(TypesClient);

  async getDirectoryStates(): Promise<TypeModel[]> {
    if (this.directoryStates.length) {
      return this.directoryStates;
    }

    this.directoryStates = await this.#typesClient.getStates();

    return this.directoryStates;
  }

  async getDirectoryEntitytypes(): Promise<OrganizationDirectoryEntityType[]> {
    if (this.directoryEntitytypes.length) {
      return this.directoryEntitytypes;
    }

    this.directoryEntitytypes = await this.#directoryClient.getEntityTypes();
    return this.directoryEntitytypes;
  }
}
